import React, {useEffect} from 'react'
import {useAuth} from "../../contexts/auth";


const Tatenergosbyt = () => {

    const auth = useAuth()
    const dogovor = auth.selectedDog

 useEffect(() => { (async function(){
 })() },[])


 return ( <>
         <div className="album bg-light tatenergosbyt">
             <div className="container-fluid">
                 {/*<div className="row  ml-4 mr-4">
                     <div className="col-lg-2 col-md-6 col-sm-6">
                         <a className="card shadow-sm" href='/#/add-dogovor'>
                             <div className="card-body">
                                 <img src='images/dogovor-icon.svg' alt='Договор'/>
                                 <div className="card-text">Заключить договор <br/>онлайн</div>
                             </div>
                         </a>
                     </div>
                     <div className="col-lg-2 col-md-6 col-sm-6 mt20xs">
                         <a className="card shadow-sm" target='_blank' rel="noreferrer" href='https://sbis.ru/'>
                             <div className="card-body">
                                 <img src='images/monitor-icon.svg' alt='Документооборот'/>
                                 <div className="card-text">Электронный<br/>документооборот
                                 </div>
                             </div>
                         </a>
                     </div>
                     <div className="col-lg-2 col-md-6 col-sm-6 mt20md mt20lg">
                         <a className="card shadow-sm" target='_blank' rel="noreferrer" href='https://tatenergosbyt.ru/b2b/payment/price/'>
                             <div className="card-body">
                                 <img src='images/card-icon.svg' alt='Тарифы'/>
                                 <div className="card-text">Тарифы и порядок<br/>определения цен
                                 </div>
                             </div>
                         </a>
                     </div>
                     <div className="col-lg-2 col-md-6 col-sm-6 mt20md mt20lg">
                         <a className="card shadow-sm" target='_blank' rel="noreferrer" href='https://tatenergosbyt.ru/b2b/payment/calculator-all/'>
                             <div className="card-body">
                                 <img src='images/calc-icon.svg' alt='Калькулятор'/>
                                 <div className="card-text">Калькулятор<br/>стоимости
                                 </div>
                             </div>
                         </a>
                     </div>
                     <div className="col-lg-2 col-md-6 col-sm-6 mt20md mt20lg">
                         <a className="card shadow-sm" target='_blank' rel="noreferrer" href='https://tatenergosbyt.ru/b2b/contract/disconnections/'>
                             <div className="card-body">
                                 <img src='images/calendar-icon.svg' alt='Отключения'/>
                                 <div className="card-text">Отключения по условиям договора
                                 </div>
                             </div>
                         </a>
                     </div>
                     <div className="col-lg-2 col-md-6 col-sm-6 mt20md mt20lg">
                         <a className="card shadow-sm" rel="noreferrer" href='/#/'>
                             <div className="card-body">

                                 <div className="card-text">
                                 </div>
                             </div>
                         </a>
                     </div>
                 </div>*/}

                <div className='tatenergo2'>
                    <div className="top-services main-page__top-services">
                     <div className="container-tat top-services__container">
                         <ul className="reset-list top-services-list top-services__list">
                             <li className="top-services-list__item">
                                 <a className="reset-link top-service-card foc-bord act-bright-d"
                                    href="/#/add-dogovor/tat">
                                     <div className="top-service-card__content">
                                         <img className='top-service-card__icon' src='images/dogovor-icon.svg' alt='Договор'/>
                                         <div className="top-service-card__info">
                                             <div
                                                 className="top-service-card__title top-service-card__title_xl-max-width-160px">
                                                 Заключить договор <br/>онлайн
                                             </div>
                                         </div>
                                     </div>
                                 </a>
                             </li>
                             <li className="top-services-list__item">
                                 <a className="reset-link top-service-card foc-bord act-bright-d"
                                    target='_blank' rel="noopener noreferrer" href={dogovor?.link ? dogovor.link : 'https://sbis.ru/'}>
                                     <div className="top-service-card__pic">
                                                  <img className="lozad top-service-card__img" data-loaded='true'
                                                  src="images/top-services_invoice.jpg" alt=""/>
                                     </div>
                                     <div className="top-service-card__content">
                                         <img src='images/monitor-icon.svg' alt='Документооборот'/>
                                         <div className="top-service-card__info">
                                             <div className="top-service-card__title">
                                                 Электронный<br/>документооборот
                                             </div>
                                         </div>
                                     </div>
                                 </a>
                             </li>
                             <li className="top-services-list__item">
                                 <a className="reset-link top-service-card top-service-card_dark-blue foc-bord act-bright-d"
                                    target='_blank' rel="noreferrer" href='https://tatenergosbyt.ru/b2b/payment/price/'>
                                     <div className="top-service-card__content">
                                         <img src='images/card-icon.svg' alt='Тарифы'/>
                                         <div className="top-service-card__info">
                                             <div
                                                 className="top-service-card__title top-service-card__title_xl-max-width-200px">
                                                 Тарифы и порядок<br/>определения цен
                                             </div>
                                         </div>
                                     </div>
                                 </a>
                             </li>

                             <li className="top-services-list__item">
                                 <a className="reset-link top-service-card foc-bord act-bright-d"
                                    target='_blank' rel="noreferrer" href='https://tatenergosbyt.ru/b2b/payment/calculator-all/'>
                                     <div className="top-service-card__pic">
                                         <img className="lozad top-service-card__img" data-loaded='true'
                                              src="images/top-services_invoice-02.jpg" alt=""/>
                                     </div>
                                     <div className="top-service-card__content">
                                         <img src='images/calc-icon.svg' alt='Калькулятор'/>
                                         <div className="top-service-card__info">
                                             <div className="top-service-card__title">
                                                 Калькулятор<br/>стоимости
                                             </div>
                                         </div>
                                     </div>
                                 </a>
                             </li>
                             <li className="top-services-list__item">
                                 <a className="reset-link top-service-card foc-bord act-bright-d"
                                    target='_blank' rel="noreferrer" href='https://tatenergosbyt.ru/b2b/contract/disconnections/'>
                                     <div className="top-service-card__content">
                                         <img src='images/calendar-icon.svg' alt='Отключения'/>
                                         <div className="top-service-card__info">
                                             <div
                                                 className="top-service-card__title top-service-card__title_xl-max-width-200px">
                                                 Отключения по <br/>условиям договора
                                             </div>
                                         </div>
                                     </div>
                                 </a>
                             </li>
                         </ul>
                     </div>
                 </div>
                </div>
             </div>
         </div>
 </>)
}

export default Tatenergosbyt



